import React from 'react'
import { Pane, Text } from 'evergreen-ui'
import { useStatusContent } from '../../../config/roundContent'

const StatusRegister_41 = ({ DataRegister }) => {
  const row = DataRegister?.[0] || {}
  const { statusContent } = useStatusContent(row.ROB_ID, "41")
  const noteLabel = statusContent.noteText || 'หมายเหตุ*'
  const body = statusContent.bodyText ||
    '1. ผู้ที่ได้รับการคัดเลือกเป็นตัวสำรอง มหาวิทยาลัยฯ จะประกาศผลการคัดเลือก เข้าศึกษาต่อเพิ่มเติมสำหรับทะเบียนสำรอง (ตัวสำรอง) ในวันที่ 30 เมษายน 2569'

  return (
    <>
      <Pane
        hidden={row.REGISTER_ORDER_NUMBER === null}
        color="#8a2846"
        backgroundColor="#ffe5ec"
        height="100%"
        paddingY={4}
        paddingX={5}
        fontSize={14}
        fontFamily=""
        margin={0}
        marginTop={0}
        fontWeight={700}
      >
        {statusContent.titleText
          ? `${statusContent.titleText} ${row.REGISTER_ORDER || ''}`.trim()
          : `ผ่านการคัดเลือกเป็น ${row.REGISTER_ORDER}`}
      </Pane>
      <Pane
        hidden={row.REGISTER_ORDER_NUMBER1 === null}
        color="#8a2846"
        backgroundColor="#ffe5ec"
        height="100%"
        paddingY={4}
        paddingX={5}
        fontSize={14}
        fontFamily=""
        margin={0}
        marginTop={8}
        fontWeight={700}
      >
        ผ่านการคัดเลือกเป็น {row.REGISTER_ORDER1}
      </Pane>
      {(statusContent.noteVisible !== false) && (
        <Pane display="flex" flexDirection="column" marginTop={8}>
          <Text color="red">{noteLabel}</Text>
          {body ? <Text fontSize={"12px"}>{body}</Text> : null}
        </Pane>
      )}
    </>
  )
}

export default StatusRegister_41
